import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AbRelatorioLgpd } from "app/abstract/full-pages/relatorios/relatorio-lgpd.abstract";

@Injectable({ providedIn: 'root' })
export class RelatorioLgpdService extends AbRelatorioLgpd {

    constructor(http: HttpClient) {
        super(http);
    }

    getListRelatorioDistribuidor(filter: String): Observable<any> {
        return this.get(`admin/relatorio_lgpd/distribuidor/${filter}`);
    }

    getListRelatorioIntegrador(filter: String): Observable<any> {
        return this.get(`admin/relatorio_lgpd/integrador/${filter}`);
    }

    getRelatorioDistribuidor(filter: string): Observable<any> {
        return this.get(`admin/relatorio_lgpd/distribuidor/gerar/${filter}`);
    }

    getRelatorioIntegrador(filter: string): Observable<any> {
        return this.get(`admin/relatorio_lgpd/integrador/gerar/${filter}`);
    }

    getTermosUso() {
        return this.get(`admin/relatorio_lgpd/termosuso`);
    }

    getPoliticaPrivacidade() {
        return this.get(`admin/relatorio_lgpd/politicaprivacidade`);
    }
}